import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StoreGetter from "@/constants/StoreGetter";
import { IDType } from "@/model/IDType";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import IDTypeValidation from "./S081200-IDTypeValidation.js";
import Paginate from "vuejs-paginate";
var IDTypeValidationObj = new IDTypeValidation();
export default {
    name: "IDType",
    mounted() {
        IDTypeValidationObj.idDocValidation();
        this.assignRights();
        this.getAllIdTypes();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_IDType,
        dictEnum: dictEnum,
        Setting: Setting,
        IDType: new IDType(),
        isEditMode: false,
        IDTypeList: [],
        selectAllIDType: false,
        tempIDTypeModel: new IDType(),
        take: 10,
        skip: 0,
        totalNoOfPages: 0,
        noOfPages: 5,
        currentSelectedPage: 0,
        currentPage: this.currentSelectedPage + 1,
        totalRecords: 0,
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        async getAllIdTypes() {
            var self = this;
            var obj = {}
            const response = await StaffService.getAllIdTypes(obj);
            if (response.data.IsSuccess) {
                self.IDTypeList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllIDTypeRecord: function () {
            var self = this;
            var IsSelected = self.selectAllIDType;
            self.IDTypeList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultipleIDTypePopup: function () {
            var arrayList = [];
            var self = this;
            self.IDTypeList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            if (arrayList.length > 0) {
                $('#deleteIDTypeListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultipleIDType() {
            var arrayList = [];
            var self = this;
            $('#deleteIDTypeListModel').modal('hide');
            self.IDTypeList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            const obj = {
                idTypeList: arrayList,
            };
            const response = await StaffService.deleteIdTypes(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetIDType();
                await self.getAllIdTypes();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        OnIDTypeSelect: function (model) {
            this.tempIDTypeModel = model;
        },
        addIDType: function () {
            var self = this;
            $('#IDTypeModel').modal('show');
            self.isEditMode = false;
            self.IDType = new IDType();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async saveIDTypeDetail(obj) {
            var self = this;
            const response = await StaffService.addIdType(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetIDType();
                await self.getAllIdTypes();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editIDType(obj) {
            var self = this;
            const response = await StaffService.updateIdType(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetIDType();
                await self.getAllIdTypes();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async saveIDType() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#IDTypeModel').modal('hide');
                    const obj = {
                        model: {
                            IDType: self.IDType.IDType,
                            CDesc: self.IDType.CDesc,
                            EDesc: self.IDType.EDesc,
                        }
                    };
                    if (self.isEditMode) {
                        self.editIDType(obj);
                    }
                    else {
                        self.saveIDTypeDetail(obj);
                    }
                }
            });
        },
        async editIDTypeDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.tempIDTypeModel.IDType != "") {
                self.IDType = this.tempIDTypeModel;
                self.$validator.reset();
                self.vErrors.clear();
                $('#IDTypeModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetIDType: function () {
            var self = this;
            self.selectAllIDType = false;
            self.isEditMode = false;
            self.IDType = new IDType();
            self.tempIDTypeModel = new IDType();
            self.$validator.reset();
            self.vErrors.clear();
            self.take = 10;
            self.skip = 0;
            self.totalNoOfPages = 0;
            self.noOfPages = 5;
            self.currentSelectedPage = 0;
            self.currentPage = self.currentSelectedPage + 1;
            self.totalRecords = 0;
        },
        closeIDTypePopup: function () {
            var self = this;
            self.selectAllIDType = false;
            self.isEditMode = false;
            self.IDType = new IDType();
            self.tempIDTypeModel = new IDType();
            self.$validator.reset();
            self.vErrors.clear();
            $('#IDTypeModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081200-IDDoc/S081200-IDDoc.js